import _ from "lodash"
import { useState, useEffect, useContext } from "react"
import { FirebaseContext } from "../../../firebase"
import { Button } from "primereact/button"

import { LoaderSmall } from "../../../components/Loaders"
import FilePreview from "../../../pages/Form/components/FilePreview"

export default function TypeFile({ value, type }) {
  const [loading, setLoading] = useState(true)
  const [downloadUrl, setDownloadURL] = useState(null)
  const firebase = useContext(FirebaseContext)

  const { getStorage, ref, getDownloadURL } = firebase.storage

  useEffect(() => {
    const getDownloadURLFromStorage = async (path) => {
      const storage = getStorage()
      const fileRef = ref(storage, path)
      const downloadURL = await getDownloadURL(fileRef)
      setDownloadURL(downloadURL)
    }
    !_.isEmpty(value) && getDownloadURLFromStorage(value)
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (_.isEmpty(value)) return <div>No file</div>

  if (loading) return <LoaderSmall />

  const handleDownloadFile = () => {
    const xhr = new XMLHttpRequest()
    xhr.responseType = "blob"
    const getFilename = () => {
      const splitPath = _.split(value, "/")
      return splitPath[splitPath.length - 1]
    }
    const filename = getFilename()
    xhr.onload = () => {
      const blob = xhr.response
      const link = document.createElement("a")
      link.href = URL.createObjectURL(blob)
      link.download = filename
      link.click()
    }
    xhr.open("GET", downloadUrl)
    xhr.send()
  }

  return (
    <div>
      <FilePreview path={value} fieldType={type} />
      <br/>
      <Button
        className="btn-sm"
        onClick={() => handleDownloadFile()}
        style={{ marginRight: 10 }}
      >
        Download
      </Button>
    </div>
  )
}
